export default {"src":"/_next/static/media/faq-icon10.eeb253a2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};